export default __webpack_public_path__ + "static/media/pdf.7acd6adf.svg";